import Vue from 'vue';

/**
 * サンプルクラス
 * @constructor
 */
class VueAchievementTab {

  constructor() {
    this.init();
  }
  /**
   * サンプル
   */
  init() {
    if (document.getElementById('js-vueAchievementTab')) {
      this.setVue();
    }
  }
  setVue() {
    let app = new Vue({
      el: '#js-vueAchievementTab',
      data() {
        return {
          tabNum: 1,
          tabClass: 'p-achievementTab__num--1',
          activeCategory: 'すべて見る',
          tabItems: [],
          buildingData: []
        };
      },
      async created() {
        await fetch('/assets/json/vue_achievement_tab.json') // publicにあるJSONを取得
          .then(response => response.json())
          .then(response => {
            const jsonData = response;
            const jsonCategoryData = jsonData[0].category;
            const jsonBuildingData = jsonData[0].buildingData;

            for (let i = 0; i < jsonCategoryData.length; i++) {
              this.tabItems.push(jsonCategoryData[i]);
            }
            for (let i = 0; i < jsonBuildingData.length; i++) {
              this.buildingData.push(jsonBuildingData[i]);
            }
          })
          .catch(error => {
              console.error('JSONを取得出来ませんでした', error);
          });
      },
      methods: {
        activate(category,tabId){
          this.activeCategory = category;
          this.tabNum = tabId;
        },
        onEnter(el) {
          el.parentElement.classList.add('p-achievementContents');
        }
      },
      watch: {
        tabNum: {
          handler() {
            this.tabClass = `p-achievementTab__num--${this.tabNum}`;
          },
          deep: true
        },
      }
    });
  }
}

export default VueAchievementTab;
